export class Pdf
{
	buttons = document.querySelectorAll('[data-s~="Pdf"]')
    target

	constructor(store)
	{
        this.store = store
	}

	pdf()
	{
		location.href = "/"+this.store.slugs.pdf+this.target
	}

	watch()
	{
        this.buttons.forEach(e => {
            e.addEventListener("click", () => {
                this.target = this.store.route.path
				this.pdf()
			})
		})
	}
}
